import "./AnalyticsReporting.module.css";
import Header from "@/reusable_sections/Header";
import Analytics from "./sections/Analytics";
import Why from "./sections/Why";
import Dashboard from "./sections/Dashboard";
import Footer from "@/reusable_sections/Footer";
export default function AnalyticsReportingPage() {
  return <div>
      <Header />
      <Analytics />
      <Dashboard />
      <Why />
      <Footer />
    </div>;
}